export default __webpack_public_path__ + "static/media/presentationCalendar.0fe3b78e.png";